export { PartnerLogoComponent } from './partner-logo.component';
